var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.UserhistoryList.id)?_c('div',{staticClass:"RadarEvaluation_box"},[_c('div',{ref:"chartContainer",staticClass:"dimension_graph"}),_c('div',{staticClass:"graph_name flex-align-center",class:_vm.fontSizeStyle[_vm.IndexNum]},[_vm._v(_vm._s(_vm.UserhistoryList.shortName))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }